// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../../shared/src/DomUtils.bs.js");
var DateUtils = require("../../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_NewShift = require("../../types/WebTypes_NewShift.bs.js");
var FormalityCompat__Form = require("re-formality/src/FormalityCompat__Form.bs.js");
var BrowserComponents_Field = require("../../../../shared-browser/src/components/BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Calendar = require("../../../../shared-browser/src/components/BrowserComponents_Calendar.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_PostAShiftForm = require("../../components/WebComponents_PostAShiftForm.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");
var BrowserComponents_SubmissionErrorModal = require("../../../../shared-browser/src/components/BrowserComponents_SubmissionErrorModal.bs.js");

var timeInput = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.rem(10.0)),
      tl: /* [] */0
    });

var timeContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.justifyContent("center"),
      tl: /* [] */0
    });

var error = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.textAlign(BrowserStyle.center),
        tl: /* [] */0
      }
    });

var Styles = {
  timeInput: timeInput,
  timeContainer: timeContainer,
  error: error
};

function initialState(timezone) {
  return {
          dates: /* [] */0,
          startTime: "",
          endTime: "",
          hasConfirmedLongShiftIsOk: false,
          hasConfirmedEarlyMorningIsOk: false,
          timezone: timezone
        };
}

function get(param) {
  return param.dates;
}

function update(setState, state, dates) {
  return Curry._2(setState, /* Dates */0, {
              dates: dates,
              startTime: state.startTime,
              endTime: state.endTime,
              hasConfirmedLongShiftIsOk: state.hasConfirmedLongShiftIsOk,
              hasConfirmedEarlyMorningIsOk: state.hasConfirmedEarlyMorningIsOk,
              timezone: state.timezone
            });
}

function validator_validate(param) {
  if (param.dates) {
    return Relude_Result.ok(/* Valid */0);
  } else {
    return Relude_Result.error("Must have at least 1 date selected");
  }
}

var validator = {
  field: /* Dates */0,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate
};

var DatesField = {
  get: get,
  update: update,
  validator: validator
};

function get$1(param) {
  return param.startTime;
}

function update$1(setState, state, startTime) {
  return Curry._2(setState, /* StartTime */1, {
              dates: state.dates,
              startTime: startTime,
              endTime: state.endTime,
              hasConfirmedLongShiftIsOk: state.hasConfirmedLongShiftIsOk,
              hasConfirmedEarlyMorningIsOk: state.hasConfirmedEarlyMorningIsOk,
              timezone: state.timezone
            });
}

function validator_validate$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$1, WebTypes_NewShift.Dates.ShiftTime.fromString, param);
                            }), (function (param) {
                              return Relude_Result.fromOption("Invalid start time selected. Please format it like '1:00 PM'", param);
                            }), param);
              }), (function (param) {
                return Relude_Result.map((function (param) {
                              return Relude_Globals.$$const(/* Valid */0, param);
                            }), param);
              }), param);
}

var validator$1 = {
  field: /* StartTime */1,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$1
};

var StartTimeField = {
  get: get$1,
  update: update$1,
  validator: validator$1
};

function get$2(param) {
  return param.endTime;
}

function update$2(setState, state, endTime) {
  return Curry._2(setState, /* EndTime */2, {
              dates: state.dates,
              startTime: state.startTime,
              endTime: endTime,
              hasConfirmedLongShiftIsOk: state.hasConfirmedLongShiftIsOk,
              hasConfirmedEarlyMorningIsOk: state.hasConfirmedEarlyMorningIsOk,
              timezone: state.timezone
            });
}

function validator_validate$2(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$2, WebTypes_NewShift.Dates.ShiftTime.fromString, param);
                            }), (function (param) {
                              return Relude_Result.fromOption("Invalid end time selected. Please format it like '6:00 PM'", param);
                            }), param);
              }), (function (param) {
                return Relude_Result.map((function (param) {
                              return Relude_Globals.$$const(/* Valid */0, param);
                            }), param);
              }), param);
}

var validator$2 = {
  field: /* EndTime */2,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$2
};

var EndTimeField = {
  get: get$2,
  update: update$2,
  validator: validator$2
};

function get$3(param) {
  return param.hasConfirmedLongShiftIsOk;
}

function update$3(setState, state, hasConfirmedLongShiftIsOk) {
  return Curry._2(setState, /* HasConfirmedLongShiftIsOk */3, {
              dates: state.dates,
              startTime: state.startTime,
              endTime: state.endTime,
              hasConfirmedLongShiftIsOk: hasConfirmedLongShiftIsOk,
              hasConfirmedEarlyMorningIsOk: state.hasConfirmedEarlyMorningIsOk,
              timezone: state.timezone
            });
}

var HasConfirmedLongShiftIsOkField = {
  get: get$3,
  update: update$3
};

function get$4(param) {
  return param.hasConfirmedEarlyMorningIsOk;
}

function update$4(setState, state, hasConfirmedEarlyMorningIsOk) {
  return Curry._2(setState, /* HasConfirmedEarlyMorningIsOk */4, {
              dates: state.dates,
              startTime: state.startTime,
              endTime: state.endTime,
              hasConfirmedLongShiftIsOk: state.hasConfirmedLongShiftIsOk,
              hasConfirmedEarlyMorningIsOk: hasConfirmedEarlyMorningIsOk,
              timezone: state.timezone
            });
}

var HasConfirmedEarlyMorningIsOkField = {
  get: get$4,
  update: update$4
};

function get$5(param) {
  return param.timezone;
}

var TimezoneField = {
  get: get$5
};

function getJsDate($staropt$star, date, timezone, param) {
  var requiresDayIncrement = $staropt$star !== undefined ? $staropt$star : false;
  return DateUtils.getDateInForcedTimezone(timezone, DateUtils.getLuxonDate(new Date(date.getFullYear(), date.getMonth(), requiresDayIncrement ? date.getDate() + 1.0 : date.getDate(), param.hours, param.minutes))).toJSDate();
}

function isLongShift(startTime, endTime, date, timezone) {
  if (Curry._2(WebTypes_NewShift.Dates.ShiftTime.eq, startTime, endTime)) {
    return true;
  } else {
    return Curry._2(Relude_Float.lessThanOrEq, 10.0, DateUtils.hoursBetween(getJsDate(undefined, date, timezone, startTime), getJsDate(Curry._2(WebTypes_NewShift.Dates.ShiftTime.compare, endTime, startTime) !== "greater_than", date, timezone, endTime)));
  }
}

function isEarlyMorningShift(param) {
  return Curry._2(Relude_Float.lessThanOrEq, param.hours, 6.0);
}

function fromDates(param) {
  var timezone = param.timezone;
  var endTime = param.endTime;
  var startTime = param.startTime;
  var dates = param.dates;
  return {
          dates: Relude_Array.toList(dates),
          startTime: Curry._1(WebTypes_NewShift.Dates.ShiftTime.toString, startTime),
          endTime: Curry._1(WebTypes_NewShift.Dates.ShiftTime.toString, endTime),
          hasConfirmedLongShiftIsOk: Relude_Option.fold(false, (function (date) {
                  return isLongShift(startTime, endTime, date, timezone);
                }), Relude_Array.head(dates)),
          hasConfirmedEarlyMorningIsOk: isEarlyMorningShift(startTime),
          timezone: timezone
        };
}

var IOWithSubmissionError = Relude_IO.WithError({});

function toDates(state) {
  return Relude_IO.fromOption((function (param) {
                return Relude_Globals.$$const(/* ValidationError */3, param);
              }), Curry._2(Relude_Option.mapTuple2, (function (startTime, endTime) {
                    return {
                            dates: Relude_Array.fromList(get(state)),
                            startTime: startTime,
                            endTime: endTime,
                            timezone: get$5(state)
                          };
                  }), [
                  Curry._1(WebTypes_NewShift.Dates.ShiftTime.fromString, get$1(state)),
                  Curry._1(WebTypes_NewShift.Dates.ShiftTime.fromString, get$2(state))
                ]));
}

function requiresLongShiftConfirmation(state) {
  return Relude_IO.flatMap((function (param) {
                var timezone = param.timezone;
                var endTime = param.endTime;
                var startTime = param.startTime;
                return Relude_Option.foldLazy((function (param) {
                              return Relude_IO.$$throw(/* ValidationError */3);
                            }), (function (date) {
                              if (get$3(state) || !isLongShift(startTime, endTime, date, timezone)) {
                                return Relude_IO.pure(undefined);
                              } else {
                                return Relude_IO.$$throw(/* RequiresLongShiftConfirmation */1);
                              }
                            }), Relude_Array.head(param.dates));
              }), toDates(state));
}

function requiresEarlyMorningConfirmation(state) {
  return Relude_IO.flatMap((function (param) {
                if (get$4(state) || !isEarlyMorningShift(param.startTime)) {
                  return Relude_IO.pure(undefined);
                } else {
                  return Relude_IO.$$throw(/* RequiresEarlyMorningConfirmation */0);
                }
              }), toDates(state));
}

function shiftStartIsTooSoon(state) {
  return Relude_IO.flatMap((function (param) {
                var now = param[1];
                var match = param[0];
                var timezone = match.timezone;
                var startTime = match.startTime;
                return Relude_Option.foldLazy((function (param) {
                              return Relude_IO.$$throw(/* ValidationError */3);
                            }), (function (jsStartTime) {
                              if (Curry._2(Relude_Float.lessThan, 2.0, DateUtils.hoursBetween(now, jsStartTime)) && DateUtils.isAfter(undefined, undefined, now)(jsStartTime)) {
                                return Relude_IO.pure(undefined);
                              } else {
                                return Relude_IO.$$throw(/* ShiftStartIsTooSoon */2);
                              }
                            }), Relude_Option.map((function (date) {
                                  return getJsDate(undefined, date, timezone, startTime);
                                }), Relude_Array.head(match.dates)));
              }), Curry._2(IOWithSubmissionError.mapTuple2, (function (dates, now) {
                    return [
                            dates,
                            now
                          ];
                  }), [
                  toDates(state),
                  DateUtils.getNowInIO(undefined)
                ]));
}

function toDates$1(state) {
  return Curry._2(IOWithSubmissionError.mapTuple4, (function (dates, param, param$1, param$2) {
                return dates;
              }), [
              toDates(state),
              requiresLongShiftConfirmation(state),
              requiresEarlyMorningConfirmation(state),
              shiftStartIsTooSoon(state)
            ]);
}

var validators_1 = {
  hd: validator$1,
  tl: {
    hd: validator$2,
    tl: /* [] */0
  }
};

var validators = {
  hd: validator,
  tl: validators_1
};

var Form = {
  initialState: initialState,
  DatesField: DatesField,
  StartTimeField: StartTimeField,
  EndTimeField: EndTimeField,
  HasConfirmedLongShiftIsOkField: HasConfirmedLongShiftIsOkField,
  HasConfirmedEarlyMorningIsOkField: HasConfirmedEarlyMorningIsOkField,
  TimezoneField: TimezoneField,
  getJsDate: getJsDate,
  isLongShift: isLongShift,
  isEarlyMorningShift: isEarlyMorningShift,
  fromDates: fromDates,
  IOWithSubmissionError: IOWithSubmissionError,
  requiresLongShiftConfirmation: requiresLongShiftConfirmation,
  requiresEarlyMorningConfirmation: requiresEarlyMorningConfirmation,
  shiftStartIsTooSoon: shiftStartIsTooSoon,
  toDates: toDates$1,
  validators: validators
};

var FormContainer = FormalityCompat__Form.Make({
      validators: validators
    });

function showSubmissionError(onClose, param) {
  switch (param) {
    case /* RequiresEarlyMorningConfirmation */0 :
        return React.createElement(BrowserComponents_SubmissionErrorModal.make, {
                    cancelButton: {
                      text: "Change Time",
                      onClick: Curry._1(onClose, false)
                    },
                    image: /* StopwatchUtensils */84,
                    okButton: {
                      text: "This Shift Starts Early",
                      onClick: Curry._1(onClose, true)
                    },
                    subtext: "Please confirm that the shift you're attempting to post starts in the early AM. We would hate for one of our Professionals to show up during the wrong time.",
                    title: "This shift starts early in the morning"
                  });
    case /* RequiresLongShiftConfirmation */1 :
        return React.createElement(BrowserComponents_SubmissionErrorModal.make, {
                    cancelButton: {
                      text: "Change Time",
                      onClick: Curry._1(onClose, false)
                    },
                    image: /* StopwatchUtensils */84,
                    okButton: {
                      text: "I Have A Really Long Shift",
                      onClick: Curry._1(onClose, true)
                    },
                    subtext: "Please confirm that the shift you're attempting to post is over 10 hours long. We would hate for one of our Professionals to show up during the wrong time.",
                    title: "This shift is more than 10 hours long"
                  });
    case /* ShiftStartIsTooSoon */2 :
        return React.createElement(BrowserComponents_SubmissionErrorModal.make, {
                    cancelButton: {
                      text: "Change Time",
                      onClick: Curry._1(onClose, false)
                    },
                    image: /* StopwatchUtensils */84,
                    subtext: "",
                    title: "Sorry, this shift must be posted 2 hours in advance"
                  });
    case /* ValidationError */3 :
        return null;
    
  }
}

function WebContainers_PostAShift_ShiftDates(Props) {
  var param = Props.newShift;
  var setShiftDates = Props.setShiftDates;
  var goBack = Props.goBack;
  var layout = Props.layout;
  var timezone = Props.timezone;
  var match = Curry._2(FormContainer.useForm, Relude_Option.fold(initialState(timezone), fromDates, param.dates), (function (state, param) {
          var notifyOnFailure = param.notifyOnFailure;
          var partial_arg = Curry._1(Relude_IO.mapError, (function (param) {
                  return Relude_Globals.$$const(/* ValidationError */3, param);
                }));
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold(notifyOnFailure, Relude_Globals.id, param);
                      }), Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(setShiftDates, partial_arg, param);
                          }), toDates$1(state)));
        }));
  var dismissSubmissionError = match.dismissSubmissionError;
  var submit = match.submit;
  var blur = match.blur;
  var change = match.change;
  var result = match.result;
  var status = match.status;
  var state = match.state;
  ReactIO.useHandledIOOnMount(undefined)(DomUtils.$$Window.scrollToTop);
  var tmp;
  if (typeof status === "number" || status.TAG !== /* SubmissionFailed */1) {
    tmp = null;
  } else {
    var submissionError = status._0;
    tmp = showSubmissionError((function (isOk) {
            return Relude_IO.suspend(function (param) {
                        var tmp;
                        switch (submissionError) {
                          case /* RequiresEarlyMorningConfirmation */0 :
                              tmp = (function (param) {
                                  return update$4(change, state, param);
                                });
                              break;
                          case /* RequiresLongShiftConfirmation */1 :
                              tmp = (function (param) {
                                  return update$3(change, state, param);
                                });
                              break;
                          case /* ShiftStartIsTooSoon */2 :
                              tmp = (function (prim) {
                                  
                                });
                              break;
                          case /* ValidationError */3 :
                              tmp = (function (prim) {
                                  
                                });
                              break;
                          
                        }
                        return Curry._1(isOk ? submit : (function (prim) {
                                        
                                      }), Curry._1(dismissSubmissionError, tmp(isOk)));
                      });
          }), submissionError);
  }
  return React.createElement(WebComponents_PostAShiftForm.LegacyForm.make, {
              children: null,
              onBackButtonClick: goBack,
              submit: submit,
              subtitle: "When is your event happening?",
              testIdPrefix: "",
              title: "Date"
            }, React.createElement(BrowserComponents_Calendar.make, {
                  initialSelectedDates: state.dates,
                  layout: layout,
                  onUpdate: (function (param) {
                      return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                    return Relude_IO.map((function (param) {
                                                  return update(change, state, param);
                                                }), param);
                                  }), param);
                    }),
                  testId: "PostAShiftCalendar"
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_ValidationError.make, {
                  className: error,
                  validationResult: Curry._1(result, /* Dates */0)
                }), tmp, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                  subtitle: "When should we show up?",
                  title: "Time"
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  className: timeContainer,
                  children: null
                }, React.createElement(BrowserComponents_FlexColumn.make, {
                      className: timeInput,
                      children: null
                    }, React.createElement(BrowserComponents_Field.Title.make, {
                          title: "Start Time"
                        }), React.createElement(BrowserComponents_Input.Legacy.Time.make, {
                          onBlur: (function (param) {
                              return Curry._1(blur, /* StartTime */1);
                            }),
                          onChange: (function (param) {
                              return update$1(change, state, param);
                            }),
                          testId: "StartTimeInput",
                          value: state.startTime
                        })), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(BrowserComponents_FlexColumn.make, {
                      className: timeInput,
                      children: null
                    }, React.createElement(BrowserComponents_Field.Title.make, {
                          title: "End Time"
                        }), React.createElement(BrowserComponents_Input.Legacy.Time.make, {
                          onBlur: (function (param) {
                              return Curry._1(blur, /* EndTime */2);
                            }),
                          onChange: (function (param) {
                              return update$2(change, state, param);
                            }),
                          testId: "EndTimeInput",
                          value: state.endTime
                        }))), React.createElement(BrowserComponents_ValidationError.make, {
                  className: error,
                  validationResult: Relude_Option.alt(Curry._1(result, /* EndTime */2), Curry._1(result, /* StartTime */1))
                }));
}

var make = WebContainers_PostAShift_ShiftDates;

exports.Styles = Styles;
exports.Form = Form;
exports.FormContainer = FormContainer;
exports.showSubmissionError = showSubmissionError;
exports.make = make;
/* timeInput Not a pure module */
